import script from "./Button.vue?vue&type=script&setup=true&lang=ts"
export * from "./Button.vue?vue&type=script&setup=true&lang=ts"

import "./Button.vue?vue&type=style&index=0&id=56d08439&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56d08439"]])

export default __exports__